import { API as Api, Auth } from 'aws-amplify'
import * as Sentry from '@sentry/browser'

export const signOut = () => {
  sessionStorage.removeItem('expiration_date')

  Auth.signOut().then(() => {
    Sentry.withScope(scope => {
      scope.setLevel(Sentry.Severity.Debug)
      scope.setTag('feature', 'logout')
      Sentry.captureMessage('Logout')
    })

    Sentry.configureScope(scope => {
      scope.setUser({})
    })
    window.location.reload()
  })
}

export const updateTimeStamp = () => {
  const date = Number(sessionStorage.getItem('expiration_date'))
  if (new Date().getTime() > date) {
    signOut()
    return
  }

  sessionStorage.setItem('expiration_date', String(new Date().getTime() + 1000 * 60 * 60 * 5))
}

export const API = {
  get: (apiName: string, path: string, options: any): Promise<any> => {
    updateTimeStamp()
    return Api.get(apiName, path, options)
  },
  post: (apiName: string, path: string, options: any): Promise<any> => {
    updateTimeStamp()
    return Api.post(apiName, path, options)
  },
  del: (apiName: string, path: string, options: any): Promise<any> => {
    updateTimeStamp()
    return Api.del(apiName, path, options)
  },
  endpoint: (apiName: string): Promise<any> => {
    updateTimeStamp()
    return Api.endpoint(apiName)
  },
}
